import React from 'react'
import Api from '../../Api'
import LB from './LB'
import MMLB from './MMLB'
import FP from './FP'
import VP from './VP'
import CC from './CC'
import MMO from './MMO'
import ZLP from './ZLP'
import LBQR from './LBQR'
import PHC from './PHC'
import QD from './QD'
import BQR from './BQR'
import CTC from './CTC'
import Components from '$Deposits/Components'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import Modal from './Components/Modal'
import OtpPopup from './Components/OtpPopup'
import { connect } from "react-redux";
import { setDepositTriggerFrom } from '$Deposits/store/actions/DepositAction'

class Deposit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const {setDepositTriggerFrom,triggerFor,vendor} = this.props;
        setDepositTriggerFrom({from:triggerFor, vendor})
    }
    componentWillUnmount() {

    }

    render() {
        const { BackClick } = GetParamsData()


        return (
            <div className='DepositCenter'>
                <div className='methods'>
                    <Components
                        isMethodsCode={true}
                        Modal={() => { return (<></>) }}
                        Banner={(propCon) => { return (<></>) }}
                        MethodsView={(propCon) => { return (<></>) }}
                        MethodsCode={(propCon) => {
                            const { activeCode } = propCon
                            return (<>
                                {activeCode == 'LB' && <LB />}
                                {activeCode == 'FP' && <FP />}
                                {activeCode == 'BQR' && <BQR />}
                                {activeCode == 'CC' && <CC />}
                                {activeCode == 'CTC' && <CTC />}
                                {activeCode == 'VP' && <VP />}
                                {activeCode == 'MMLB' && <MMLB />}
                                {activeCode == 'MMO' && <MMO />}
                                {activeCode == 'ZLP' && <ZLP />}
                                {activeCode == 'LBQR' && <LBQR />}
                                {activeCode == 'PHC' && <PHC />}
                                {activeCode == 'QD' && <QD />}
                            </>)
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = () =>{}

const mapDispatchToProps = {
    setDepositTriggerFrom: (data)=>setDepositTriggerFrom(data)
};

export default connect(mapStateToProps, mapDispatchToProps)(Deposit)

export class Methods extends React.Component {
    renderClass(item) {
        return `${item.isFast ? 'isFast ' : ''}${item.isNew ? 'isNew ' : ''}${item.isHot ? 'isHot ' : ''}`.trim();
    }
    
    render() {
        return (
            <div className='DepositCenter'>
                <div className='methods'>
                    {/* <OtpPopup /> */}
                    <Components
                        Banner={(propCon) => { return (<></>) }}
                        MethodsView={(propCon) => {
                            return (
                                <div className='methodsList deposit-list'>
                                    {
                                        propCon.paymentMethods.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => { (this.props.useCentralPayment && item.code == 'CTC') ? this?.props?.toggleCentralPaymentHandler(item.code) : propCon.onChange(item) }}
                                                    className={`deposit-item ${(propCon.activeCode == item.code ? 'active ' : ' ')}`}
                                                >
                                                    <div className={`deposit-sprite ${item.code}`} />
                                                    <span>{item.name}</span>
                                                    <div className={`${this.renderClass(item)}`} />
                                                    {item.code === 'CTC' && <div className='externalLinkIcon' />}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        }}
                        MethodsCode={(propCon) => { return (<></>) }}
                    />
                </div>
            </div>
        )
    }
}

export class DepositHeader extends React.Component {

    render() {
        const { LivechatClick } = GetParamsData()
        const { leftClick = () => { }, rightClick = () => { LivechatClick() }, title, disalbeLeftBtn = false } = this.props
        return (
            <div className='DepositHeader'>
                <div onClick={leftClick}>
                    {
                        !disalbeLeftBtn && <div className='backIcon' />
                    }
                    {
                        disalbeLeftBtn && <div className='leftTtransparent' />
                    }
                </div>
                <p className='headerTitle'>{title || 'Gửi Tiền'}</p>
                <div onClick={rightClick} className='csIcon' />
            </div>
        )
    }
}


